import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/articles";

const footerLinks = [
  {
    title: "热门分类",
    links: categories.slice(0, 4).map((c) => ({ label: c.name, href: `/category/${c.slug}` })),
  },
  {
    title: "快速链接",
    links: [
      { label: "最新爆料", href: "/category/tahouse" },
      { label: "热搜榜单", href: "/" },
      { label: "独家深扒", href: "/category/exclusive" },
      { label: "关于我们", href: "/about" },
    ],
  },
  {
    title: "友情链接",
    links: [
      { label: "娱乐新闻", href: "#", external: true },
      { label: "明星动态", href: "#", external: true },
      { label: "影视资讯", href: "#", external: true },
    ],
  },
  {
    title: "联系我们",
    links: [
      { label: "商务合作", href: "/about" },
      { label: "侵权投诉", href: "/about" },
      { label: "用户协议", href: "#", external: true },
      { label: "隐私政策", href: "#", external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold mb-4 pb-2 border-b border-background-50/20">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.href}
                        className="text-sm text-background-50/65 hover:text-background-50 transition-colors"
                        rel="nofollow"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm text-background-50/65 hover:text-background-50 transition-colors"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 md:mt-18 pt-10 border-t border-background-50/15">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div className="flex items-baseline gap-2">
              <span className="text-3xl md:text-4xl font-black tracking-tight">黑料</span>
              <span className="text-3xl md:text-4xl font-black tracking-tight text-background-50/70">吃瓜</span>
              <span className="w-8 h-px bg-background-50/40 mx-2"></span>
              <span className="text-xs text-background-50/50">{siteInfo.tagline}</span>
            </div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              <p className="text-xs text-background-50/45">
                &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="抖音">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}